import React from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useOrdersContext } from '../../store/order/order-context';
import { setCancelOrder } from '../../store/order/actions/order';

interface Props {
	closeModal: () => void;
	orderId: string;
}

export const CancelOrderModal = (props: Props): React.ReactElement => {
	const { closeModal, orderId } = props;
	const { orderContextState: { isCancelOrderLoading } ,dispatch } = useOrdersContext();

	const handleConfirm = async (): Promise<void> => {
		await setCancelOrder(dispatch, orderId);
		closeModal();
	};

	return (
		<>
			<div className="text-center mt-10 fs-6">Attention! this action cannot be undone</div>
			<div className="text-center fs-6">A notification email will be sent to the user informing him </div>
			<div className="d-flex align-items-center justify-content-center mt-15 pb-10">
				<ButtonComponent
					buttonName='Cancel'
					additionalClass="btn-sm me-20"
					buttonType={BUTTON_TYPE.CANCELLED}
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName='Confirm'
					additionalClass="btn-sm w-100px"
					onButtonClick={handleConfirm}
					isDisabled={isCancelOrderLoading}
					loading={isCancelOrderLoading}
				/>
			</div>
		</>
	);
};
